import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white/95 backdrop-blur-md ${
        isScrolled ? 'shadow-md' : ''
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center">
            <button
              onClick={() => scrollToSection('hero')}
              className="flex items-center gap-3 hover:opacity-80 transition-opacity"
            >
              <img
                src="/obrador_logo.jpg"
                alt="Obrador Pomodoro"
                className="h-12 w-12 rounded-full object-cover"
              />
              <span
                className="text-2xl font-bold text-[#C1272D] hidden sm:inline"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                Obrador Pomodoro
              </span>
            </button>
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-[#C1272D] transition-colors font-medium"
            >
              Nosotros
            </button>
            <button
              onClick={() => scrollToSection('menu')}
              className="text-gray-700 hover:text-[#C1272D] transition-colors font-medium"
            >
              Menú
            </button>
            <button
              onClick={() => scrollToSection('reviews')}
              className="text-gray-700 hover:text-[#C1272D] transition-colors font-medium"
            >
              Opiniones
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-[#C1272D] transition-colors font-medium"
            >
              Ubicación
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-[#C1272D] hover:bg-[#A01F25] text-white px-6 py-2 transition-colors"
            >
              Reservar
            </Button>
          </nav>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-gray-700 hover:text-[#C1272D] transition-colors"
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden pb-4 bg-white rounded-b-lg shadow-lg">
            <nav className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('about')}
                className="text-gray-700 hover:text-[#C1272D] transition-colors font-medium text-left px-4"
              >
                Nosotros
              </button>
              <button
                onClick={() => scrollToSection('menu')}
                className="text-gray-700 hover:text-[#C1272D] transition-colors font-medium text-left px-4"
              >
                Menú
              </button>
              <button
                onClick={() => scrollToSection('reviews')}
                className="text-gray-700 hover:text-[#C1272D] transition-colors font-medium text-left px-4"
              >
                Opiniones
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-gray-700 hover:text-[#C1272D] transition-colors font-medium text-left px-4"
              >
                Ubicación
              </button>
              <div className="px-4">
                <Button
                  onClick={() => scrollToSection('contact')}
                  className="w-full bg-[#C1272D] hover:bg-[#A01F25] text-white transition-colors"
                >
                  Reservar
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
